
class AudioPlayer {
  private player: HTMLElement | null;
  private audio?: HTMLAudioElement | null;
  private playButton?: HTMLButtonElement | null;
  private progressBar?: HTMLInputElement | null;
  private currentTimeEl?: HTMLElement | null;
  private remainingTimeEl?: HTMLElement | null;

  constructor() {

    this.player = document.querySelector('[data-audio-player]');
    if (!this.player) return
    this.audio = this.player.querySelector<HTMLAudioElement>('[data-audio-src]');
    const audioUrl = this.player?.dataset.src;
    if (!audioUrl || !this.audio) return;
    this.audio.src = audioUrl;
    this.playButton = this.player.querySelector<HTMLButtonElement>('[data-play-button]');
    this.progressBar = this.player.querySelector<HTMLInputElement>('[data-progress-bar]');
    this.currentTimeEl = this.player.querySelector<HTMLElement>('[data-current-time]');
    this.remainingTimeEl = this.player.querySelector<HTMLElement>('[data-remaining-time]');
    this._init();
  }


  private _init(): void {
    if (!this.audio || !this.playButton || !this.progressBar || !this.remainingTimeEl || !this.currentTimeEl) {
      return;
    }

    this.audio.addEventListener('loadedmetadata', () => {
      this.progressBar!.max = String(this.audio!.duration);
      this.remainingTimeEl!.textContent = this.formatTime(this.audio!.duration);
    });

    this.playButton.addEventListener('click', () => this.togglePlay());
    this.progressBar.addEventListener('input', () => {
      this.audio!.currentTime = parseFloat(this.progressBar!.value);

    });

    this.audio.addEventListener('timeupdate', () => {
      const percentage = (this.audio!.currentTime / this.audio!.duration) * 100;
      this.progressBar!.value = String(this.audio!.currentTime);
      this.progressBar!.style.setProperty('--progress-percentage', `${percentage}%`);
      this.currentTimeEl!.textContent = this.formatTime(this.audio!.currentTime);
      const remainingSeconds = this.audio!.duration - this.audio!.currentTime;
      this.remainingTimeEl!.textContent = this.formatTime(remainingSeconds);
    });

  }

  private togglePlay(): void {
    if (!this.audio || !this.playButton) return;

    if (this.audio.paused) {
      this.audio.play();
      this.playButton.classList.add('is-playing');
      this.playButton.setAttribute('aria-label', 'Pause');
    } else {
      this.audio.pause();
      this.playButton.classList.remove('is-playing');
      this.playButton.setAttribute('aria-label', 'Lire');
    }
  }

  private formatTime(timeInSeconds: number): string {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }
}

export const audioPlayer = new AudioPlayer();
